"use strict";

var _defineProperty = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/defineProperty");

var _apiKeys, _urls, _Object$freeze;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getConfiguration = void 0;

var schemas_1 = require("@dcl/schemas");

var types_1 = require("./types");

var configuration = Object.freeze((_Object$freeze = {
  storageKey: 'decentraland-connect-storage-key'
}, _defineProperty(_Object$freeze, types_1.ProviderType.INJECTED, {}), _defineProperty(_Object$freeze, types_1.ProviderType.FORTMATIC, {
  apiKeys: (_apiKeys = {}, _defineProperty(_apiKeys, schemas_1.ChainId.ETHEREUM_MAINNET, 'pk_live_F8E24DF8DD5BCBC5'), _defineProperty(_apiKeys, schemas_1.ChainId.ETHEREUM_ROPSTEN, 'pk_test_5B728BEFE5C10911'), _defineProperty(_apiKeys, schemas_1.ChainId.ETHEREUM_RINKEBY, 'pk_test_5B728BEFE5C10911'), _defineProperty(_apiKeys, schemas_1.ChainId.ETHEREUM_KOVAN, 'pk_test_5B728BEFE5C10911'), _apiKeys)
}), _defineProperty(_Object$freeze, types_1.ProviderType.WALLET_CONNECT, {
  urls: (_urls = {}, _defineProperty(_urls, schemas_1.ChainId.ETHEREUM_MAINNET, 'https://mainnet.infura.io/v3/fa3357a65e2d4214ac735190646a3c53'), _defineProperty(_urls, schemas_1.ChainId.ETHEREUM_ROPSTEN, 'https://ropsten.infura.io/v3/fa3357a65e2d4214ac735190646a3c53'), _defineProperty(_urls, schemas_1.ChainId.ETHEREUM_RINKEBY, 'https://rinkeby.infura.io/v3/fa3357a65e2d4214ac735190646a3c53'), _defineProperty(_urls, schemas_1.ChainId.ETHEREUM_KOVAN, 'https://kovan.infura.io/v3/fa3357a65e2d4214ac735190646a3c53'), _urls)
}), _Object$freeze));

function getConfiguration() {
  return configuration;
}

exports.getConfiguration = getConfiguration;